import { Attachment } from '../../../shared/models/attachment';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CandidateStore } from '../../../dashboards/store/candidate-store';
import { Experience } from '../../../shared/models/experience';

@Component({
  selector: 'app-experience-form',
  templateUrl: './experience-form.component.html',
  styleUrls: ['./experience-form.component.scss'],
})
export class ExperienceFormComponent implements OnInit {
  @Output() resetAttachmentFormEvent = new EventEmitter<void>();

  @Input() experience: Experience;
  @Input() index: number;
  @Input() collapse_experience: boolean;
  @Output() saved: EventEmitter<any> = new EventEmitter();

  public form: FormGroup;
  buttonText: string = "Add";
  today = new Date();
  fromDate: { year: number; month: number; day: number; };
  todayCalendar = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
  maxDate = this.todayCalendar;

  get minfromDate() {
    return this.form.get('fromDate').value;
  }

  constructor(
    private formBuilder: FormBuilder,
    private dashboardState: CandidateStore
  ) {
    const today = new Date();
    this.form = this.formBuilder.group({
      title: [''],
      company: [''],
      fromDate: [this.todayCalendar],
      toDate: [this.todayCalendar],
      currentJob: [false],
      description: [''],
    });
  }

  ngOnInit() {

    let existingExperience = true;
    if (!this.experience) {
      existingExperience = false;
      this.experience = new Experience();
      this.experience.id = (
        '0'.repeat(24) + Math.floor(Math.random() * 16 ** 24).toString(16)
      ).slice(-24);
      this.experience.fromDate = this.today;
      this.experience.toDate = this.today;
    }

    if(existingExperience) {
      this.buttonText = "Save"
    }

    this.form.patchValue({ title: this.experience.title });
    this.form.patchValue({ company: this.experience.company });
    this.form.patchValue({ fromDate: this.todayCalendar });
    this.form.patchValue({ toDate: this.todayCalendar });
    this.form.patchValue({ currentJob: this.experience.currentJob});
    this.form.patchValue({ description: this.experience.description });
  }

  save(): void {
    if (!this.form.valid) {
      return;
    }

    const experience = Experience.parseForm(this.form);
    let injectedInstance = this.dashboardState.getExperiences().find(ex => ex.id == this.experience.id);
    this.index = this.dashboardState.getExperiences().findIndex(x => x.id == this.experience.id);

    if(!injectedInstance) {
      this.dashboardState.addExperience(experience);
      this.resetAttachmentFormEvent.emit();
      this.form.reset();
      this.saved.emit();
      return;
    }

    injectedInstance.title = experience.title;
    injectedInstance.company = experience.company;
    injectedInstance.description = experience.description;
    injectedInstance.toDate = experience.toDate;
    injectedInstance.currentJob = experience.currentJob;
    injectedInstance.fromDate = experience.fromDate;

    this.dashboardState.updateExperience(injectedInstance, this.index);
    this.resetAttachmentFormEvent.emit();
    this.form.reset();
    this.saved.emit();
  }
}
